<template>
  <div>
    <!-- start action dropdown-->
    <v-layout
      v-if="editPermission"
      row
    >
      <v-select
        v-model="dropdown.action"
        :disabled="!dropdownEnabled"
        :items="dropdownItems"
        item-value="value"
        item-test="text"
        label="Choose Action"
        solo
      />
      <!-- only show if cancel is slected-->
      <v-select
        v-if="dropdown.action == 'cancel'"
        v-model="dropdown.confirmCancel"
        :disabled="!dropdownEnabled"
        :items="confirmationMenu"
        item-value="value"
        item-test="text"
        label="Are You sure?"
        solo
      />
      <!-- only show if any action is selected -->
      <v-btn
        v-if="String(dropdown.action) != 'false' && dropdown.confirmCancel"
        @click="performAction()"
      >
        Apply
      </v-btn>
    </v-layout>
    <!-- end action dropdown -->
    <!-- start parking bookings -->
    <div v-max-height="{height: '50vh'}">
      <v-alert
        :value="!parkingBookings.length && !loading"
        type="info"
      >
        No Results
      </v-alert>
      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
      />
      <v-card-item
        v-for="parkingBooking in parkingBookings"
        :key="parkingBooking.parkingBookingID"
      >
        <template slot="title">
          <v-flex xs4>
            {{ parkingBooking.parkingName }}
          </v-flex>
          <v-flex
            xs-4
            class="pl-5"
          >
            <IconButton
              :to="'/print/parking/' + parkingBooking.parkingBookingID"
              tooltip="View"
              color="indigo"
              icon="fa-print"
            />
            <template v-if="editPermission">
              <IconButton
                tooltip="Subtract Gate Pass"
                icon="fa-minus-square"
                @click="updateGatePassUnassign({parkingBookingID: parkingBooking.parkingBookingID})"
              />
              {{ parkingBooking.gatePasses }}
              <IconButton
                tooltip="Add Gate Pass"
                icon="fa-plus-square"
                @click="updateGatePassAssign({parkingBookingID: parkingBooking.parkingBookingID})"
              />
            </template>
          </v-flex>
          <v-flex xs4 />
        </template>
        <template
          v-if="editPermission"
          slot="actions"
        >
          <v-checkbox
            :value="parkingBooking.parkingBookingID"
            v-model="selectedParkingBookings"
            type="checkbox"
            class="text-xs-right"
          />
        </template>
        <template>
          <v-layout row>
            <v-flex xs8>
              <strong>ID:</strong> {{ parkingBooking.parkingBookingID }}<br>
              <strong>Date:</strong> {{ parkingBooking.reservedDate }}<br>
              <strong>Vehicle:</strong> {{ parkingBooking.vehicleMake }} -  {{ parkingBooking.vehicleModel }}
            </v-flex>
            <v-flex>
              <strong>Price:</strong> ${{ parkingBooking.price }}
            </v-flex>
          </v-layout>
        </template>
      </v-card-item>
      <v-layout justify-center>
        <v-btn
          flat
          color="primary"
          @click="showOlder=!showOlder"
        >
          <template v-if="showOlder">
            Hide Older
          </template>
          <template v-else>
            Show Older
          </template>
        </v-btn>
      </v-layout>
    </div>
    <!-- end parking bookings -->
  </div>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      showOlder: false,
      loading: true,
      dropdownItems: [
        {
          value: 'cancel',
          text: 'Cancel'
        }
      ],
      confirmationMenu: [
        {
          value: false,
          text: 'No'
        },
        {
          value: true,
          text: 'Yes'
        }
      ],
      dropdown: {
        action: false,
        confirmCancel: null
      },
      selectedParkingBookings: []
    }
  },
  computed: {
    ...mapGetters({
      $parkingBookings: 'parkingBookings/parkingBookings'
    }),
    dropdownEnabled () {
      return Boolean(this.selectedParkingBookings.length)
    },
    editPermission () {
      return this.assertSetting('editReservations', 1)
    },
    parkingBookings () {
      if (!this.showOlder) {
        return this.$parkingBookings.filter((parkingBooking) => {
          let currentDate = this.$moment()
          let endDate = this.$moment(parkingBooking.reservedDate)
          return endDate.isSameOrAfter(currentDate, 'day')
        })
      }
      return this.$parkingBookings
    }
  },
  mounted () {
    this.getParkingBookings().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      getParkingBookings: 'parkingBookings/getParkingBookings',
      deleteParkingBookings: 'parkingBookings/deleteParkingBookings',
      getBaxterBucks: 'person/getBaxterBucks',
      getGatePasses: 'passes/getGatePasses',
      updateGatePassAssign: 'passes/updateGatePassAssign',
      updateGatePassUnassign: 'passes/updateGatePassUnassign'
    }),
    refresh () {
      this.loading = true
      // reload gate gatePasses
      this.getGatePasses()
      // reload the bookings
      this.getParkingBookings().then(() => {
        this.loading = false
      })
      this.selectedParkingBookings = []
      // reload baxter bucks in case anything changed
      this.getBaxterBucks()
    },
    performAction () {
      switch (this.dropdown.action) {
        case 'cancel':
          this.cancelReservations()
          break
        default:
          console.log('no action selected')
      }
    },
    cancelReservations () { // cancel the selected reservations
      if (!this.dropdown.confirmCancel) { // confirmation dropdown must be yes
        return
      }
      // delete parkingBookings
      this.deleteParkingBookings({ parkingBookingIDs: this.selectedParkingBookings }).then(this.refresh)
    }
  }
}
</script>
